import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PublicRoute from './PublicRoute';
import Login from 'pages/login/Login';
import ForgotPassword from 'pages/forgot-password/ForgotPassword';
import ResetPassword from 'pages/reset-password/ResetPassword';
import ProtectedRoute from './ProtectedRoute';
import ConstructionPage from 'pages/construction/ConstructionPage';
import Home from 'pages/home/Home';
import ExecutiveDashboard from 'pages/executive-dashboard/ExecutiveDashboard';
import Account from 'pages/account/Account';
import Users from 'pages/users/Users';
import NewUser from 'pages/users/registration/new/NewUser';
import EditUser from 'pages/users/registration/edit/EditUser';
import Doctor from 'pages/doctor/Doctor';
import NewDoctor from 'pages/doctor/registration/new/NewDoctor';
import EditDoctor from 'pages/doctor/registration/edit/EditDoctor';
import Patient from 'pages/patient/Patient';
import NewPatient from 'pages/patient/registration/new/NewPatient';
import EditPatient from 'pages/patient/registration/edit/EditPatient';
import Specialty from 'pages/specialty/Specialty';
import NewSpecialty from 'pages/specialty/registration/new/NewSpecialty';
import EditSpecialty from 'pages/specialty/registration/edit/EditSpecialty';
import Product from 'pages/product/Product';
import NewProduct from 'pages/product/registration/new/NewProduct';
import EditProduct from 'pages/product/registration/edit/EditProduct';
import Supplier from 'pages/supplier/Supplier';
import NewSupplier from 'pages/supplier/registration/new/NewSupplier';
import EditSupplier from 'pages/supplier/registration/edit/EditSupplier';
import Consultation from 'pages/consultation/Procedure';
import Procedure from 'pages/procedure/Procedure';
import Package from 'pages/package/Package';
import NewPackage from 'pages/package/registration/new/NewPackage';
import EditPackage from 'pages/package/registration/edit/EditPackage';
import EditProcedure from 'pages/procedure/registration/edit/EditProcedure';
import NewProcedure from 'pages/procedure/registration/new/NewProcedure';
import EditConsultation from 'pages/consultation/registration/edit/EditProcedure';
import NewConsultation from 'pages/consultation/registration/new/NewProcedure';
import Hospital from 'pages/hospital/Hospital';
import NewHospital from 'pages/hospital/registration/new/NewHospital';
import EditHospital from 'pages/hospital/registration/edit/EditHospital';
import SurgerieOpen from 'pages/surgerie/open/SurgerieOpen';
import SurgerieClosed from 'pages/surgerie/closed/SurgerieClosed';
import SurgerieNew from 'pages/surgerie/new/SurgerieNew';
import SurgerieImport from 'pages/surgerie/import/SurgerieImport';
import SurgerieRecord from 'pages/surgerie/record/SurgerieRecord';
import PrintSurgerie from 'pages/surgerie/print/PrintSurgerie';
import AccessRules from 'pages/access-rules/AccessRules';
import EditAccessRule from 'pages/access-rules/registration/edit/EditAccessRule';
import NewAccessRule from 'pages/access-rules/registration/new/NewAccessRule';
import Profiles from 'pages/user-profiles/Profiles';
import NewProfile from 'pages/user-profiles/new/NewProfile';
import EditProfile from 'pages/user-profiles/edit/EditProfile';
import Guide from 'pages/guide/Guide';
import NewGuide from 'pages/guide/registration/NewGuide';
import PaymentMethod from 'pages/payment-method/PaymentMethod';
import NewPaymentMethod from 'pages/payment-method/registration/new/NewPaymentMethod';
import EditPaymentMethod from 'pages/payment-method/registration/edit/EditPaymentMethod';
import PrintGuide from 'pages/guide/dialog/PrintGuide';
import Reports from 'pages/reports/Reports';
import ReportGuide from 'pages/reports/guides/ReportGuide';
import ReportSurgerie from 'pages/reports/surgeries/ReportSurgerie';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="*" element={<ProtectedRoute element={<ConstructionPage />} />} />

      <Route path="/" element={<ProtectedRoute element={<Home />} />} />
      <Route path="/executive-dashboard" element={<ProtectedRoute rule="reports" element={<ExecutiveDashboard />} />} />
      <Route path="/account" element={<ProtectedRoute element={<Account />} />} />

      <Route path="/users" element={<ProtectedRoute rule="registrations.users" element={<Users />} />} />
      <Route path="/users/new" element={<ProtectedRoute rule="settings.user-control.users" element={<NewUser />} />} />
      <Route path="/users/:id" element={<ProtectedRoute rule="settings.user-control.users" element={<EditUser />} />} />

      <Route path="/doctors" element={<ProtectedRoute rule="registrations.doctors" element={<Doctor />} />} />
      <Route path="/doctors/new" element={<ProtectedRoute rule="registrations.doctors" element={<NewDoctor />} />} />
      <Route path="/doctors/:id" element={<ProtectedRoute rule="registrations.doctors" element={<EditDoctor />} />} />

      <Route path="/patients" element={<ProtectedRoute rule="registrations.patients" element={<Patient />} />} />
      <Route path="/patients/new" element={<ProtectedRoute rule="registrations.patients" element={<NewPatient />} />} />
      <Route
        path="/patients/:id"
        element={<ProtectedRoute rule="registrations.patients" element={<EditPatient />} />}
      />

      <Route
        path="/specialties"
        element={<ProtectedRoute rule="registrations.specialties" element={<Specialty />} />}
      />
      <Route
        path="/specialties/new"
        element={<ProtectedRoute rule="registrations.specialties" element={<NewSpecialty />} />}
      />
      <Route
        path="/specialties/:id"
        element={<ProtectedRoute rule="registrations.specialties" element={<EditSpecialty />} />}
      />

      <Route path="/products" element={<ProtectedRoute rule="registrations.products" element={<Product />} />} />
      <Route path="/products/new" element={<ProtectedRoute rule="registrations.products" element={<NewProduct />} />} />
      <Route
        path="/products/:id"
        element={<ProtectedRoute rule="registrations.products" element={<EditProduct />} />}
      />

      <Route path="/suppliers" element={<ProtectedRoute rule="registrations.suppliers" element={<Supplier />} />} />
      <Route
        path="/suppliers/new"
        element={<ProtectedRoute rule="registrations.suppliers" element={<NewSupplier />} />}
      />
      <Route
        path="/suppliers/:id"
        element={<ProtectedRoute rule="registrations.suppliers" element={<EditSupplier />} />}
      />

      <Route path="/procedures" element={<ProtectedRoute rule="registrations.procedures" element={<Procedure />} />} />
      <Route
        path="/procedures/new"
        element={<ProtectedRoute rule="registrations.procedures" element={<NewProcedure />} />}
      />
      <Route
        path="/procedures/:id"
        element={<ProtectedRoute rule="registrations.procedures" element={<EditProcedure />} />}
      />

      <Route
        path="/consultation"
        element={<ProtectedRoute rule="ambulatory.consultation" element={<Consultation />} />}
      />
      <Route
        path="/consultation/new"
        element={<ProtectedRoute rule="ambulatory.consultation" element={<NewConsultation />} />}
      />
      <Route
        path="/consultation/:id"
        element={<ProtectedRoute rule="ambulatory.consultation" element={<EditConsultation />} />}
      />

      <Route path="/packages" element={<ProtectedRoute rule="registrations.packages" element={<Package />} />} />
      <Route path="/packages/new" element={<ProtectedRoute rule="registrations.packages" element={<NewPackage />} />} />
      <Route
        path="/packages/:id"
        element={<ProtectedRoute rule="registrations.packages" element={<EditPackage />} />}
      />

      <Route path="/hospitals" element={<ProtectedRoute rule="registrations.hospitals" element={<Hospital />} />} />
      <Route
        path="/hospitals/new"
        element={<ProtectedRoute rule="registrations.hospitals" element={<NewHospital />} />}
      />
      <Route
        path="/hospitals/:id"
        element={<ProtectedRoute rule="registrations.hospitals" element={<EditHospital />} />}
      />

      <Route path="/surgeries/open" element={<ProtectedRoute rule="surgeries.open" element={<SurgerieOpen />} />} />
      <Route
        path="/surgeries/closed"
        element={<ProtectedRoute rule="surgeries.closed" element={<SurgerieClosed />} />}
      />
      <Route path="/surgeries/new" element={<ProtectedRoute rule="surgeries.new" element={<SurgerieNew />} />} />
      <Route path="/surgeries/import" element={<ProtectedRoute rule="surgeries.new" element={<SurgerieImport />} />} />
      <Route path="/surgeries/:id" element={<ProtectedRoute rule="surgeries" element={<SurgerieRecord />} />} />
      <Route
        path="/surgeries/:status/:id/print"
        element={<ProtectedRoute rule="surgeries" element={<PrintSurgerie />} />}
      />

      <Route
        path="/user-profiles"
        element={<ProtectedRoute rule="settings.user-control.user-profiles" element={<Profiles />} />}
      />
      <Route
        path="/user-profile"
        element={<ProtectedRoute rule="settings.user-control.user-profiles" element={<NewProfile />} />}
      />
      <Route
        path="/user-profile/:id"
        element={<ProtectedRoute rule="settings.user-control.user-profiles" element={<EditProfile />} />}
      />

      <Route
        path="/access-rules"
        element={<ProtectedRoute rule="settings.user-control.access-rules" element={<AccessRules />} />}
      />
      <Route
        path="/access-rule/:id"
        element={<ProtectedRoute rule="settings.user-control.access-rules" element={<EditAccessRule />} />}
      />
      <Route
        path="/access-rule"
        element={<ProtectedRoute rule="settings.user-control.access-rules" element={<NewAccessRule />} />}
      />

      <Route
        path="/payment-methods"
        element={<ProtectedRoute rule="registrations.payment-methods" element={<PaymentMethod />} />}
      />
      <Route
        path="/payment-methods/new"
        element={<ProtectedRoute rule="registrations.payment-methods" element={<NewPaymentMethod />} />}
      />
      <Route
        path="/payment-methods/:id"
        element={<ProtectedRoute rule="registrations.payment-methods" element={<EditPaymentMethod />} />}
      />

      <Route path="/guides" element={<ProtectedRoute rule="ambulatory.guides" element={<Guide />} />} />
      <Route path="/guides/new" element={<ProtectedRoute rule="ambulatory.guides" element={<NewGuide />} />} />
      <Route path="/guides/:id/print" element={<ProtectedRoute rule="ambulatory.guides" element={<PrintGuide />} />} />

      <Route path="/reports" element={<ProtectedRoute rule="reports" element={<Reports />} />} />
      <Route path="/reports/guides" element={<ProtectedRoute rule="reports" element={<ReportGuide />} />} />
      <Route
        path="/reports/surgeries"
        element={<ProtectedRoute rule="reports.surgeries" element={<ReportSurgerie />} />}
      />

      <Route path="/login" element={<PublicRoute element={<Login />} />} />
      <Route path="/forgot" element={<PublicRoute element={<ForgotPassword />} />} />
      <Route path="/password/reset/:token" element={<PublicRoute element={<ResetPassword />} />} />
      <Route path="/reset-password/:token" element={<PublicRoute element={<ResetPassword />} />} />
    </Routes>
  );
};

export default AppRoutes;
